import React, { useMemo } from "react";

const MetricCard = ({ title, value, subtitle, icon, accent }) => (
  <div className="dashboard-metric-card">
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
      <div style={{
        width: '44px', height: '44px', borderRadius: '12px',
        background: accent ? 'rgba(62, 73, 84, 0.1)' : '#f5f6f8',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: accent ? '#3E4954' : 'var(--color-muted-foreground)',
      }}>
        {icon}
      </div>
    </div>
    <div style={{ fontFamily: 'var(--font-heading)', fontSize: '36px', fontWeight: 700, color: accent ? '#3E4954' : '#1e2b38', lineHeight: 1, marginBottom: '6px', letterSpacing: '-0.02em' }}>
      {value}
    </div>
    <div style={{ fontSize: '14px', fontWeight: 600, color: '#1e2b38', fontFamily: 'var(--font-ui)', marginBottom: '4px' }}>{title}</div>
    {subtitle && (
      <div style={{ fontSize: '12px', color: 'var(--color-muted-foreground)', fontFamily: 'var(--font-ui)' }}>{subtitle}</div>
    )}
  </div>
);

const MetricsRow = ({ bookings }) => {
  const metrics = useMemo(() => {
    const total = bookings?.length || 0;
    const now = new Date();
    const weekAgo = new Date(now);
    weekAgo?.setDate(now?.getDate() - 7);
    const thisWeek = bookings?.filter(b => new Date(b?.timestamp) >= weekAgo)?.length || 0;
    const onsite = bookings?.filter(b => b?.type === "onsite")?.length || 0;
    const phone = bookings?.filter(b => b?.type === "phone")?.length || 0;
    const convRate = total > 0 ? Math.round((total / Math.max(total * 1.4, 1)) * 100) : 0;
    return { total, thisWeek, onsite, phone, convRate };
  }, [bookings]);

  const calIcon = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/>
      <line x1="8" y1="2" x2="8" y2="6"/>
      <line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  );
  const trendIcon = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
      <polyline points="17 6 23 6 23 12"/>
    </svg>
  );
  const pieIcon = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"/>
      <path d="M22 12A10 10 0 0 0 12 2v10z"/>
    </svg>
  );
  const percentIcon = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="5" x2="5" y2="19"/>
      <circle cx="6.5" cy="6.5" r="2.5"/>
      <circle cx="17.5" cy="17.5" r="2.5"/>
    </svg>
  );

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '32px' }}>
      <MetricCard
        title="Buchungen gesamt"
        value={metrics?.total}
        subtitle="Im gewählten Zeitraum"
        icon={calIcon}
        accent
      />
      <MetricCard
        title="Diese Woche"
        value={metrics?.thisWeek}
        subtitle="Letzte 7 Tage"
        icon={trendIcon}
        accent={false}
      />
      <MetricCard
        title="Vor-Ort vs. Telefon"
        value={`${metrics?.onsite} / ${metrics?.phone}`}
        subtitle={`${metrics?.onsite} Vor-Ort · ${metrics?.phone} Telefon`}
        icon={pieIcon}
        accent={false}
      />
      <MetricCard
        title="Conversion Rate"
        value={`${metrics?.convRate}%`}
        subtitle="Buchungen aus Webinaren"
        icon={percentIcon}
        accent={false}
      />
    </div>
  );
};

export default MetricsRow;
